import styled from 'styled-components';
import { COMMON, get, TYPOGRAPHY } from './constants';
import sx from './sx';
import theme from './theme';
var Heading = styled.h2.withConfig({
  displayName: "Heading",
  componentId: "sc-1cjoo9h-0"
})(["font-weight:", ";font-size:", ";margin:0;", ";", ";", ";"], get('fontWeights.bold'), get('fontSizes.5'), TYPOGRAPHY, COMMON, sx);
Heading.defaultProps = {
  theme: theme
};
export default Heading;